import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/tokens.css';
import './styles/app.css';

// Deliberately not wrapped in <StrictMode>: its double-invoked effects would
// open and immediately tear down a matchmaking ticket / game session on every
// mount in development, which the backend treats as a real disconnect.
const container = document.getElementById('root');
if (!container) throw new Error('#root container is missing from index.html');

createRoot(container).render(<App />);
